import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * The ECONIC type roles are Tailwind font sizes (apps/assistant/src/index.css `@theme`: text-body, text-callout, text-title-1 …).
 * tailwind-merge does not know them and would read `text-body` as a colour, so `cn("text-body text-label-2")` dropped the size and the
 * text fell back to 16 px. Registering them in the `text` scale keeps a size and a colour side by side, and still lets a later size
 * replace an earlier one. `text-label` is a colour (the label colour), never a size.
 */
const ECONIC_TEXT_SIZES = [
  // APPLE-SPEC §3.2 role names
  "large-title", "title-1", "doc-title", "title-2", "hero-verdict", "verdict", "headline", "body", "callout", "caption", "figure", "kpi",
  // first-pass role names (kept)
  "hero", "display", "h1", "h2", "lede", "title", "ui", "small", "tick", "num-l", "num-m", "num-s",
];

const merge = extendTailwindMerge({
  extend: {
    theme: { text: ECONIC_TEXT_SIZES },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return merge(clsx(inputs));
}
